// Ancient Conquerors & Empire Builders Data - Group One (First 6 Characters)

// Alexander the Great's workout programs
const alexanderTheGreatPrograms = [
    {
        id: 'macedonian-phalanx-training',
        name: 'Macedonian Phalanx Training',
        description: 'Synchronized strength building that creates unstoppable forward momentum like the legendary phalanx formation',
        pattern: '$x&*!=',
        reps: 16,
        sets: 4,
        focus: 'Formation Power'
    },
    {
        id: 'conquest-of-persia-conditioning',
        name: 'Conquest of Persia Conditioning',
        description: 'Epic endurance training for those who dare to conquer vast empires and impossible distances',
        pattern: '=*$&x!',
        reps: 22,
        sets: 3,
        focus: 'Empire Endurance'
    },
    {
        id: 'alexandria-builder-workout',
        name: 'Alexandria Builder Workout',
        description: 'Foundational strength that builds legendary cities and lasting monuments to greatness',
        pattern: 'x$!*&=',
        reps: 18,
        sets: 4,
        focus: 'Monument Building'
    },
    {
        id: 'godlike-warrior-protocol',
        name: 'Godlike Warrior Protocol',
        description: 'Training that transcends mortal limits, forging strength worthy of the son of Zeus',
        pattern: '&=$x*!',
        reps: 25,
        sets: 3,
        focus: 'Divine Power'
    },
    {
        id: 'hellenistic-fusion-training',
        name: 'Hellenistic Fusion Training',
        description: 'Combining Greek discipline with Eastern wisdom to create revolutionary training methods',
        pattern: '*!=$&x',
        reps: 20,
        sets: 4,
        focus: 'Cultural Fusion'
    },
    {
        id: 'world-conqueror-mastery',
        name: 'World Conqueror Mastery',
        description: 'The ultimate training regimen of history\'s greatest military genius who never lost a battle',
        pattern: '$x&*!=!',
        reps: 33,
        sets: 3,
        focus: 'Legendary Conquest'
    }
];

// Julius Caesar's workout programs
const juliusCaesarPrograms = [
    {
        id: 'gallic-wars-conditioning',
        name: 'Gallic Wars Conditioning',
        description: 'Battle-tested strength forged through eight years of relentless Gallic campaign victories',
        pattern: 'x$&)(*',
        reps: 19,
        sets: 4,
        focus: 'Campaign Endurance'
    },
    {
        id: 'crossing-rubicon-training',
        name: 'Crossing Rubicon Training',
        description: 'Bold decisive training for those who dare to cross the point of no return to greatness',
        pattern: '$)x(&*',
        reps: 15,
        sets: 5,
        focus: 'Bold Decision'
    },
    {
        id: 'dictator-for-life-workout',
        name: 'Dictator for Life Workout',
        description: 'Supreme authority conditioning that builds the strength to reshape the entire Roman world',
        pattern: '&*$x)(',
        reps: 23,
        sets: 3,
        focus: 'Supreme Authority'
    },
    {
        id: 'veni-vidi-vici-protocol',
        name: 'Veni Vidi Vici Protocol',
        description: 'Lightning conquest training - arrive, assess, dominate with unmatched efficiency',
        pattern: ')($&*x',
        reps: 17,
        sets: 4,
        focus: 'Swift Victory'
    },
    {
        id: 'clemency-and-strength-training',
        name: 'Clemency and Strength Training',
        description: 'Balanced power that shows mercy to enemies while maintaining absolute dominance',
        pattern: '*x)$(&',
        reps: 21,
        sets: 4,
        focus: 'Balanced Power'
    },
    {
        id: 'eternal-rome-mastery',
        name: 'Eternal Rome Mastery',
        description: 'The complete training system that transformed Rome into an eternal empire',
        pattern: '$x&)()*',
        reps: 44,
        sets: 3,
        focus: 'Eternal Legacy'
    }
];

// Hannibal Barca's workout programs
const hannibalBarcaPrograms = [
    {
        id: 'alpine-crossing-conditioning',
        name: 'Alpine Crossing Conditioning',
        description: 'Impossible mountain conditioning with elephants - overcoming every natural barrier',
        pattern: '=:}{[]',
        reps: 26,
        sets: 3,
        focus: 'Mountain Conquest'
    },
    {
        id: 'cannae-encirclement-training',
        name: 'Cannae Encirclement Training',
        description: 'Tactical masterpiece conditioning that surrounds and destroys larger enemy forces',
        pattern: '}[:]=:{',
        reps: 18,
        sets: 4,
        focus: 'Tactical Genius'
    },
    {
        id: 'carthaginian-naval-workout',
        name: 'Carthaginian Naval Workout',
        description: 'Mediterranean maritime strength building for the masters of ancient naval warfare',
        pattern: '[]{}:=',
        reps: 20,
        sets: 4,
        focus: 'Naval Supremacy'
    },
    {
        id: 'terror-of-rome-protocol',
        name: 'Terror of Rome Protocol',
        description: 'Psychological warfare conditioning that strikes fear into the hearts of mighty empires',
        pattern: ':={[}]',
        reps: 22,
        sets: 3,
        focus: 'Psychological Warfare'
    },
    {
        id: 'mercenary-unity-training',
        name: 'Mercenary Unity Training',
        description: 'Forging diverse warriors from different nations into one unstoppable fighting force',
        pattern: '{]=:}[',
        reps: 24,
        sets: 4,
        focus: 'Unity in Diversity'
    },
    {
        id: 'oath-of-vengeance-mastery',
        name: 'Oath of Vengeance Mastery',
        description: 'The eternal training sworn before the gods to bring down Rome\'s mighty empire',
        pattern: '=:}{[]!',
        reps: 39,
        sets: 3,
        focus: 'Sacred Vengeance'
    }
];

// Attila the Hun's workout programs
const attilaTheHunPrograms = [
    {
        id: 'horseback-warrior-training',
        name: 'Horseback Warrior Training',
        description: 'Nomadic strength that turns horse and rider into one unstoppable force of nature',
        pattern: 'ghyqnv',
        reps: 21,
        sets: 4,
        focus: 'Mounted Warfare'
    },
    {
        id: 'scourge-of-god-conditioning',
        name: 'Scourge of God Conditioning',
        description: 'Divine wrath training for those chosen to humble the pride of mighty civilizations',
        pattern: 'vnqygh',
        reps: 28,
        sets: 3,
        focus: 'Divine Wrath'
    },
    {
        id: 'hun-horde-mobilization',
        name: 'Hun Horde Mobilization',
        description: 'Lightning mobility training that strikes faster than empires can respond',
        pattern: 'hygnvq',
        reps: 16,
        sets: 5,
        focus: 'Lightning Mobility'
    },
    {
        id: 'terror-of-europe-workout',
        name: 'Terror of Europe Workout',
        description: 'Continental conquest conditioning that makes entire civilizations tremble',
        pattern: 'qvghyn',
        reps: 24,
        sets: 3,
        focus: 'Continental Terror'
    },
    {
        id: 'nomadic-endurance-protocol',
        name: 'Nomadic Endurance Protocol',
        description: 'Steppe survival training for endless journeys across hostile territories',
        pattern: 'nghyvq',
        reps: 19,
        sets: 4,
        focus: 'Steppe Endurance'
    },
    {
        id: 'apocalypse-rider-mastery',
        name: 'Apocalypse Rider Mastery',
        description: 'The ultimate training of the horseman who brought the end times to the Roman world',
        pattern: 'ghyqnv!',
        reps: 45,
        sets: 3,
        focus: 'Apocalyptic Power'
    }
];

// Napoleon Bonaparte's workout programs
const napoleonBonapartePrograms = [
    {
        id: 'artillery-emperor-training',
        name: 'Artillery Emperor Training',
        description: 'Precision power training from the master who made artillery the god of war',
        pattern: 'ekhmft',
        reps: 18,
        sets: 4,
        focus: 'Precision Artillery'
    },
    {
        id: 'continental-system-conditioning',
        name: 'Continental System Conditioning',
        description: 'Economic warfare training that conquers through commercial and military dominance',
        pattern: 'mhefkt',
        reps: 20,
        sets: 4,
        focus: 'Economic Warfare'
    },
    {
        id: 'grande-armee-workout',
        name: 'Grande Armée Workout',
        description: 'Elite military conditioning for the greatest army Europe had ever seen',
        pattern: 'ftkemh',
        reps: 22,
        sets: 3,
        focus: 'Elite Military'
    },
    {
        id: 'code-napoleon-protocol',
        name: 'Code Napoleon Protocol',
        description: 'Legal revolution training that builds lasting institutional strength and order',
        pattern: 'htmkef',
        reps: 25,
        sets: 4,
        focus: 'Legal Revolution'
    },
    {
        id: 'waterloo-redemption-training',
        name: 'Waterloo Redemption Training',
        description: 'Rising from defeat training that transforms setbacks into comebacks',
        pattern: 'kmfteh',
        reps: 15,
        sets: 6,
        focus: 'Defeat to Victory'
    },
    {
        id: 'emperor-of-europe-mastery',
        name: 'Emperor of Europe Mastery',
        description: 'The complete imperial training that reshaped European civilization forever',
        pattern: 'ekhmft!',
        reps: 40,
        sets: 3,
        focus: 'Imperial Mastery'
    }
];

// Cleopatra VII's workout programs
const cleopatraViiPrograms = [
    {
        id: 'pharaoh-divine-training',
        name: 'Pharaoh Divine Training',
        description: 'Royal conditioning worthy of the living goddess who ruled the Nile kingdom',
        pattern: 'azj+;|',
        reps: 17,
        sets: 4,
        focus: 'Divine Royalty'
    },
    {
        id: 'intellectual-seduction-workout',
        name: 'Intellectual Seduction Workout',
        description: 'Mental and physical excellence that captivated the greatest minds of Rome',
        pattern: '+;|zaj',
        reps: 19,
        sets: 4,
        focus: 'Intellectual Power'
    },
    {
        id: 'alexandria-library-conditioning',
        name: 'Alexandria Library Conditioning',
        description: 'Scholar-queen training that balances vast knowledge with physical perfection',
        pattern: 'j|a+z;',
        reps: 21,
        sets: 3,
        focus: 'Scholar Strength'
    },
    {
        id: 'nile-goddess-protocol',
        name: 'Nile Goddess Protocol',
        description: 'Ancient Egyptian training that channels the eternal power of the sacred river',
        pattern: ';za|+j',
        reps: 23,
        sets: 4,
        focus: 'Sacred River Power'
    },
    {
        id: 'last-pharaoh-training',
        name: 'Last Pharaoh Training',
        description: 'Final dynasty conditioning that preserves three thousand years of Egyptian greatness',
        pattern: '|+j;az',
        reps: 16,
        sets: 5,
        focus: 'Dynasty Preservation'
    },
    {
        id: 'eternal-egypt-mastery',
        name: 'Eternal Egypt Mastery',
        description: 'The complete training of the last great pharaoh who made Egypt immortal',
        pattern: 'azj+;|!',
        reps: 37,
        sets: 3,
        focus: 'Eternal Glory'
    }
];

// Main Ancient Conquerors & Empire Builders trainers data object - Group One
const historyOneTrainersData = {
    'alexander-the-great': {
        id: 'alexander-the-great',
        name: 'Alexander the Great',
        specialization: 'Phalanx Formation & World Conquest Training',
        image: '/assets/images/alexander-the-great.jpg',
        experience: '32+ years',
        category: 'ancient-conquerors',
        color: '#4169E1',
        secondaryColor: '#FFD700',
        intro: `The young Macedonian king who conquered the known world by age 30, Alexander perfected the art of unstoppable momentum. His training combines Greek discipline with Persian innovation, creating warriors who never retreat and never accept defeat. "There is nothing impossible to him who will try."`,
        programs: alexanderTheGreatPrograms
    },
    'julius-caesar': {
        id: 'julius-caesar',
        name: 'Julius Caesar',
        specialization: 'Roman Legion & Political Domination Training',
        image: '/assets/images/julius-caesar.jpg',
        experience: '56+ years',
        category: 'ancient-conquerors',
        color: '#8B0000',
        secondaryColor: '#DAA520',
        intro: `The Roman general who crossed the Rubicon and reshaped the world, Caesar mastered both battlefield strategy and political revolution. His training builds leaders who command absolute loyalty while achieving impossible victories. "I came, I saw, I conquered."`,
        programs: juliusCaesarPrograms
    },
    'hannibal-barca': {
        id: 'hannibal-barca',
        name: 'Hannibal Barca',
        specialization: 'Tactical Genius & Mountain Warfare Training',
        image: '/assets/images/hannibal-barca.jpg',
        experience: '63+ years',
        category: 'ancient-conquerors',
        color: '#A0522D',
        secondaryColor: '#8B4513',
        intro: `The Carthaginian general who crossed the Alps with elephants and terrorized Rome for decades. His training develops tactical brilliance and the ability to turn any disadvantage into victory. Master of the impossible, teacher of tactical perfection.`,
        programs: hannibalBarcaPrograms
    },
    'attila-the-hun': {
        id: 'attila-the-hun',
        name: 'Attila the Hun',
        specialization: 'Nomadic Warfare & Continental Terror Training',
        image: '/assets/images/attila-the-hun.jpg',
        experience: '47+ years',
        category: 'ancient-conquerors',
        color: '#2F4F4F',
        secondaryColor: '#8B4513',
        intro: `Known as the Scourge of God, Attila united the nomadic tribes and brought the Roman Empire to its knees. His training develops lightning mobility and the psychological warfare that makes empires surrender without fighting. Fear is the beginning of wisdom.`,
        programs: attilaTheHunPrograms
    },
    'napoleon-bonaparte': {
        id: 'napoleon-bonaparte',
        name: 'Napoleon Bonaparte',
        specialization: 'Artillery Mastery & Imperial Conquest Training',
        image: '/assets/images/napoleon-bonaparte.jpg',
        experience: '51+ years',
        category: 'ancient-conquerors',
        color: '#191970',
        secondaryColor: '#FFD700',
        intro: `The Artillery Emperor who rose from nothing to reshape European civilization. His training combines mathematical precision with revolutionary innovation, creating leaders who turn the impossible into the inevitable. "Impossible is a word found only in the dictionary of fools."`,
        programs: napoleonBonapartePrograms
    },
    'cleopatra-vii': {
        id: 'cleopatra-vii',
        name: 'Cleopatra VII',
        specialization: 'Intellectual Seduction & Divine Authority Training',
        image: '/assets/images/cleopatra-vii.jpg',
        experience: '39+ years',
        category: 'ancient-conquerors',
        color: '#4169E1',
        secondaryColor: '#B8860B',
        intro: `The last pharaoh of Egypt who spoke nine languages and captivated the greatest leaders of Rome. Her training develops intellectual supremacy combined with physical perfection, creating leaders who conquer through brilliance and charisma. Intelligence is the ultimate power.`,
        programs: cleopatraViiPrograms
    }
};

// Export the data
export default historyOneTrainersData;